import { FeatureFlagName } from "../../mp-utils/generic-utils/feature-flags/types"

export const FEATURE_FLAG_OVERRIDE = {
  organization: {
    organizations: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_organizations,
      type: "graphql",
      viewName: "orgViewOrganizations",
      fileName: "organizations"
    },
    states: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_states,
      type: "graphql",
      viewName: "orgViewStates",
      fileName: "states"
    },
    districts: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_districts,
      type: "graphql",
      viewName: "orgViewDistricts",
      fileName: "districts"
    },
    schools: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_schools,
      type: "graphql",
      viewName: "orgViewSchools",
      fileName: "institutions"
    },
    classes: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_classes,
      type: "graphql",
      viewName: "orgViewClasses",
      fileName: "classes"
    },
    admins: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_admins,
      type: "graphql",
      viewName: "orgViewAdmins",
      fileName: "admins"
    },
    teachers: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_teachers,
      type: "graphql",
      viewName: "orgViewTeachers",
      fileName: "instructors"
    },
    students: {
      featureFlag: FeatureFlagName.reporting_graphql_organization_students,
      type: "graphql",
      viewName: "orgViewStudents",
      fileName: "learners"
    }
  },
  insights: {
    "students-usage": {
      featureFlag: FeatureFlagName.reporting_graphql_usage_students,
      type: "graphql",
      viewName: "studentUsage",
      fileName: "student-usage"
    },
    "teachers-usage": {
      featureFlag: FeatureFlagName.reporting_graphql_usage_teachers,
      type: "graphql",
      viewName: "teacherUsage",
      fileName: "teacher-usage"
    },
    "activity-log": {
      featureFlag: FeatureFlagName.reporting_graphql_usage_activity_log,
      type: "graphql",
      viewName: "activityLog",
      fileName: "activity-log"
    },
    "details-usage": {
      featureFlag: FeatureFlagName.reporting_graphql_usage_activity_log,
      type: "graphql",
      viewName: "activityLog",
      fileName: "activity-log"
    },
    scores: {
      featureFlag: FeatureFlagName.reporting_graphql_performance_scores,
      type: "graphql",
      viewName: "performanceTestScores",
      fileName: "performance-scores"
    },
    "subtests-scores": {
      featureFlag: FeatureFlagName.reporting_graphql_performance_scores,
      type: "graphql",
      viewName: "performanceScores",
      fileName: "performance-scores"
    }
  },
  content: {
    "content-library": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary",
      fileName: "content-library"
    },
    "content-library/practice-test": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.PracticeTest",
      fileName: "content-library"
    },
    "content-library/mastery-curriculum": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.BookChapter",
      fileName: "content-library"
    },
    "content-library/mastery-lesson": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.OnlineLesson",
      fileName: "content-library"
    },
    "content-library/element": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.BellRinger",
      fileName: "content-library"
    },
    "content-library/study-hall": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.SkillReview",
      fileName: "content-library"
    },
    "content-library/downloadble-resource": {
      featureFlag: FeatureFlagName.reporting_graphql_educator_content_library,
      type: "graphql",
      viewName: "educatorContentLibrary.DigitalResource",
      fileName: "content-library"
    }
  }
}
